import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class BillingService {
  constructor(private http: HttpClientService) {}

  public getPendingToInvoice(filters): Observable<any> {
    const options = { params: filters };
    return this.http
      .get("/api/billing/pending_to_invoice", options)
      .pipe(tap((_) => console.log("BillingService.getPendingToInvoice: Ok.")));
  }

  public getCompletedInvoices(filters): Observable<any> {
    const options = { params: filters };
    return this.http
      .get("/api/billing/completed_invoices", options)
      .pipe(tap((_) => console.log("BillingService.getCompletedInvoices: Ok.")));
  }

  public getCanceledInvoices(filters): Observable<any> {
    const options = { params: filters };
    return this.http
      .get("/api/billing/canceled_invoices", options)
      .pipe(tap((_) => console.log("BillingService.getCanceledInvoices: Ok.")));
  }

  public getRejectedInvoices(filters): Observable<any> {
    const options = { params: filters };
    return this.http
      .get("/api/billing/rejected_invoices", options)
      .pipe(tap((_) => console.log("BillingService.getRejectedInvoices: Ok.")));
  }

  public getInvoiceDetails(invoice_id: number): Observable<any> {
    return this.http
      .get(`/api/billing/${  invoice_id  }/invoice_details`)
      .pipe(tap((_) => console.log("BillingService.getInvoiceDetails: Ok.")));
  }

  public updateInvoiceDetails(invoice_id: number, data: any): Observable<any> {
    return this.http
      .post(`/api/billing/${  invoice_id  }/update_pending_invoice`, data)
      .pipe(tap((_) => console.log("SinubeService.updateInvoiceDetails: Ok.")));
  }

  public billing(ids: number[], type: string): Observable<any> {
    const options = { ids, type };
    return this.http
      .post("/api/billing/billing_invoices", options)
      .pipe(tap((_) => console.log("BillingService.updateClientDetails: Ok.")));
  }

  public retryBilling(invoice_id: number, data: any): Observable<any> {
    return this.http
      .post(`/api/billing/${  invoice_id  }/retry_billing`, data)
      .pipe(tap((_) => console.log("BillingService.retryBilling: Ok.")));
  }

  public retryBillingInvoices(ids: number[], type: string): Observable<any> {
    const options = { ids, type };
    return this.http
      .post("/api/billing/retry_billing_selected_invoices", options)
      .pipe(tap((_) => console.log("BillingService.retryBillingInvoices: Ok.")));
  }

  public sendInvoiceForEmail(invoice_id: number, emails: string[]): Observable<any> {
    const payload = { emails };
    return this.http
      .post(`/api/billing/${  invoice_id  }/send_invoice_for_email`, payload)
      .pipe(tap((_) => console.log("BillingService.sendInvoiceForEmail: Ok.")));
  }

  public replaceInvoiceFiles(
    invoice_id: number,
    files: { pdf_content: string; pdf_filename: string; xml_content: string; xml_filename: string }
  ): Observable<any> {
    return this.http
      .post(`/api/billing/${  invoice_id  }/replace_invoice_files`, files)
      .pipe(tap((_) => console.log("BillingService.replaceInvoiceFiles: Ok.")));
  }
}
